export interface CacheEntry {
  value: Response;
  timestamp: number;
  expirySeconds: number;
}

class CacheManager {
  private defaultExpiry: number;
  static prefix = "cache_";

  constructor(defaultExpirationSeconds: number = 5) {
    this.defaultExpiry = defaultExpirationSeconds;
  }
  set(key: string, value: string, expirySeconds?: number): void {
    localStorage.setItem(
      `${CacheManager.prefix}_${key}`,
      JSON.stringify({
        value: value,
        timestamp: Date.now(),
        expirySeconds: expirySeconds || this.defaultExpiry,
      })
    );
    setTimeout(() => {
      this.delete(key);
    }, (expirySeconds || this.defaultExpiry) * 1000);
  }

  get(key: string): Response | undefined {
    try {
      const cacheKey = `${CacheManager.prefix}_${key}`;
      const entry = localStorage.getItem(cacheKey);
      if (!entry) {
        return undefined;
      }
      const entryParsed = JSON.parse(localStorage.getItem(cacheKey) ?? "");

      if (!entryParsed) {
        return undefined;
      }

      if (
        Date.now() - entryParsed.timestamp >
        entryParsed.expirySeconds * 1000
      ) {
        this.delete(key);
        return undefined;
      }


      return entryParsed.value;
    } catch (e) {
      return undefined;
    }
  }

  clear(): void {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(CacheManager.prefix)) {
        localStorage.removeItem(key);
      }
    }
  }

  delete(key: string): void {
    localStorage.removeItem(key);
  }

  setDefaultExpiration(seconds: number): void {
    this.defaultExpiry = seconds;
  }
}

const Caching = new CacheManager();

export default Caching;
